import { render, staticRenderFns } from "./AnchorSidebar.vue?vue&type=template&id=5d68097a"
import script from "./AnchorSidebar.vue?vue&type=script&lang=js"
export * from "./AnchorSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d68097a')) {
      api.createRecord('5d68097a', component.options)
    } else {
      api.reload('5d68097a', component.options)
    }
    module.hot.accept("./AnchorSidebar.vue?vue&type=template&id=5d68097a", function () {
      api.rerender('5d68097a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/layouts/partials/AnchorSidebar.vue"
export default component.exports